"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("@react-mdc/base");
var utils = require("./utils");
var Meta = (function (_super) {
    __extends(Meta, _super);
    function Meta() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Meta.prototype.renderBaseClassName = function () {
        return null;
    };
    Meta.prototype.renderClassValues = function () {
        var _a = this.props, color = _a.color, backgroundColor = _a.backgroundColor, textColor = _a.textColor, onColor = _a.onColor;
        var classes = [];
        if (color != null) {
            classes.push(utils.classNameForColor(color));
        }
        if (backgroundColor != null) {
            classes.push(utils.classNameForBackground(backgroundColor));
        }
        if (textColor != null && onColor != null) {
            classes.push(utils.classNameForTextColor(textColor, onColor));
        }
        return classes;
    };
    return Meta;
}(base_1.ClassNameMetaBase));
exports.Meta = Meta;
var Theme = (function (_super) {
    __extends(Theme, _super);
    function Theme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Theme.prototype.getMetaComponent = function () {
        return Meta;
    };
    Theme.prototype.getMetaPropNames = function () {
        return [
            "className",
            "color",
            "backgroundColor",
            "textColor",
            "onColor",
        ];
    };
    Theme.prototype.getChildComponent = function () {
        return "div";
    };
    Theme.Meta = Meta;
    return Theme;
}(base_1.DefaultComponentBase));
exports.default = Theme;
//# sourceMappingURL=Theme.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/theme/lib/Theme.js
// module id = ./node_modules/@react-mdc/theme/lib/Theme.js
// module chunks = 2